// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7231b482","821":"d5eb9183"}[chunkId] + ".chunk.js";
};